document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('quick-add-bulk').forEach(el => {
    // Try multiple selectors to find the product URL
    const card = el.closest('.card-wrapper, .grid__item');
    const productLink = card?.querySelector('a[href*="/products/"]');
    const productUrl = productLink?.getAttribute('href');

    if (productUrl) {
      el.style.cursor = 'pointer';
      el.addEventListener('click', (e) => {
        e.stopPropagation();
        window.location.href = productUrl;
      });
    }
  });
});
